import { reportError } from '~/utilities/errorReporting';
import type { WistiaError } from '~/datadogRum/WistiaError';
import { isNotNil } from '~/utilities/type-guards';
import { activeOnboarding } from '../activeOnboarding';
import type { Pillar, Product } from '../../../types/wistia';
import type { SupportedFeatureIds } from '../types';

export interface ExperienceConfig {
  id: string;
  pillar: Pillar;
  product: Product;
}

export interface Logger {
  error: (error: Error | WistiaError) => void;
}

export const useLogger = (featureId?: SupportedFeatureIds): Logger => {
  const config = (
    isNotNil(featureId)
      ? activeOnboarding[featureId]
      : {
          id: 'unknown',
          pillar: 'growth',
          product: 'onboarding',
        }
  ) as ExperienceConfig;

  return {
    error: (error: Error | WistiaError) => {
      reportError(error, {
        key: 'onboarding-library',
        pillar: config.pillar,
        product: config.product,
        featureId: config.id,
      });
    },
  } as Logger;
};
